import { Dispatch } from 'redux';
import { IMakeRequest } from '../../../helpers/network_helper';
import { IReduxContext } from '../../store';

import { IStore } from '../../../models/store';
import { IVacanciesState, TVacancies } from '../../../models/vacancies';
import { TReduxActions, TThunkAction } from '../../../../shared/types/redux';

const initialState: IVacanciesState = {
  data: [],
  isError: false,
  isFetching: false,
};

export const vacanciesReducer = (state = initialState, action: TReduxActions) => {
  switch (action.type) {
    case 'vacancies/GET_REQUEST':
      return { ...state, ...{ isFetching: true }};

    case 'vacancies/GET_SUCCESS':
      return { ...state, ...{ isFetching: false, data: action.data }};

    case 'vacancies/GET_FAILURE':
      return { ...state, ...{ isFetching: false, isError: true }};

    default:
      return state;
  }
};

const getVacanciesDataApi = (makeRequest: IMakeRequest, cityId: number) => {
  const headers: [string, string][] = [
    ['Content-Type', 'application/json'],
  ];

  return makeRequest({
      method: 'GET',
      uri: {
        host: window.__mainpage_vacancies_api_url__,
        path: '/v1/filter-vacancies/?pageSize=3&regionId=' + cityId,
      },
      headers,
    }).then((vacancies) => vacancies);
};

export const getVacanciesData = (): TThunkAction => {
  return (dispatch: Dispatch, getState: () => IStore, context: IReduxContext) => {
    dispatch({ type: 'vacancies/GET_REQUEST' });

    const state = getState();
    const cityId = state.mainpage.regionsData.subdomainCityId;

    getVacanciesDataApi(context.makeRequest, cityId)
      .then((response: { vacancies: TVacancies }) => {
        dispatch({ type: 'vacancies/GET_SUCCESS', data: response.vacancies });
      })
      .catch(() => {
        dispatch({ type: 'vacancies/GET_FAILURE' });
      });
  };
};
